"use client";
import * as React from "react";
import { useRouter } from "next/navigation";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import TawkTo from "../componenets/Tawko";

const steps = [
  "Ride Info",
  "Vehicle Class",
  "Passenger Info",
  "Booking Detail",
  "Payment",
];

const paths = [
  "../booking",
  "/booking/vehicle",
  "/booking/passengers-info",
  "/booking/details",
  "/booking/payment",
];

export default function HorizontalLinearStepper({ countStep }) {
  const router = useRouter();

  const [activeStep, setActiveStep] = React.useState(countStep);

  const handleStepClick = (index) => {
    if (index < countStep) {
      router.push(paths[index]);
    }
    // setActiveStep(index);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <TawkTo />
      <div
        className="pb-3 pt-3 "
        style={{ background: "rgba(245, 245, 245, 1)", marginBottom: "20px" }}
      >
        <div className="mx-auto max-w-7xl px-3  grid grid-cols-1  sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 ">
          <div className="item  col-span-1">
            <h3 className="location1 px-2  secondary">
              STEP {countStep + 1} OF 5
            </h3>
            <h1 className="  font20 px-2 -mt-2 secondary">
              {steps[countStep]}
            </h1>
          </div>
          <div className="item grid col-span-2  flex justiy-center ">
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={label} onClick={() => handleStepClick(index)}>
                  <StepLabel>
                    <div
                      className="location"
                      style={{ cursor: "pointer", color: "#2B3252" }}
                    >
                      {label}
                    </div>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
        </div>
      </div>
    </Box>
  );
}
